import type { FC } from 'react';

import { Card, Heading, Stack, Text, TextLink } from '@eneco/sparky';
import { signIn } from 'next-auth/react';


interface Props {
  textualData?: {
    loginLinkText: {
      value: string;
    };
    text: {
      value: string;
    };
    title: {
      value: string;
    };
  };
}

export const LoginCard: FC<Props> = ({ textualData }) => {
  if (!textualData) return null;

  return (
    <Stack.Item>
      <Card>
        <Card.Content>
          <Stack gap="6">
            <Heading size="XS" as="h2">
              {textualData?.title.value}
            </Heading>
            <Text size="BodyS" as="p">
              {textualData?.text.value}
            </Text>
            <TextLink emphasis="high" onClick={() => signIn('okta')}>
              Login
            </TextLink>
          </Stack>
        </Card.Content>
      </Card>
    </Stack.Item>
  );
};
